import { defineComponent as _defineComponent } from 'vue'
import { INavigationExtraItems } from "@/api/types/revenue";
import { checkRole } from "@/utils/checkRole";
import { USER_ROLES } from "@/mappings/user-roles";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import store from "@/store";
import SvgUsers from '@/assets/icons/nav-bar/users.svg';
import SvgTasks from '@/assets/icons/tasks.svg';
import SvgTasksMarker from '@/assets/icons/tasks-marker.svg';
import SvgLoginUser from '@/assets/icons/nav-bar/login-user.svg';
import { useTasksStore } from "@/store_v3/MyTasksStore";
import { storeToRefs } from "pinia";

interface Props {
    mini: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavAdministration',
  props: {
    mini: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    mini: boolean;
}

const loginRoles = [USER_ROLES.AFFILIATE_MANAGER, USER_ROLES.ACCOUNT_MANAGER, USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR, USER_ROLES.FINANCIER, USER_ROLES.SUPPORT, USER_ROLES.STAT_MANAGER, USER_ROLES.API_OPERATOR];


const router = useRouter();
const { tasksCount } = storeToRefs(useTasksStore());

const openModal = () => {
    store.commit('authModule/SET_LOGIN_AS_PARTNER',true);
};

const goToEmployees = () => {
    router.push({ name: 'users', query: { account_type: 'employee' } });
};

const goToTasks = () => {
    router.push({ name: 'tasks' });
};
const getTasksText = computed(() => tasksCount.value > 0 ? 'Задач' : 'Мои задачи');
const getTasksIcon = computed( () => tasksCount.value > 0 ? SvgTasksMarker : SvgTasks);

const administration = computed<INavigationExtraItems[]>(() => {
    return [
        {
            text: getTasksText.value,
            routeName: 'tasks',
            icon: getTasksIcon.value,
            action: goToTasks,
            counter: tasksCount.value,
        },
        {
            text: 'Сотрудники',
            routeName: 'users',
            icon: SvgUsers,
            action: goToEmployees,
        },
        {
            text: 'Войти под партнёром',
            routeName: '/',
            icon: SvgLoginUser,
            action: openModal,
        },
    ];
});

const filterLinks = () => {
    const items = checkRole(administration.value);
    const login = items.find(i => i.text === 'Войти под партнёром');
    if (login) {
        const user = store.getters['authModule/GET_USER'];
        login.show = loginRoles.some((role) => user?.roles?.includes(role));
    }
    return items;
};

const currentLinks = computed(() => {
    return filterLinks().filter(item => item.show);
});

return { __sfc: true,loginRoles, props, router, tasksCount, openModal, goToEmployees, goToTasks, getTasksText, getTasksIcon, administration, filterLinks, currentLinks }
}

})